import axios from 'axios'
import { Message } from 'element-ui'

const service = axios.create({
  baseURL: '/api',
  timeout: 15000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 延迟导入避免循环依赖
    const store = require('@/store').default
    const token = store.getters.token
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      Message({
        message: res.message || '请求失败',
        type: 'error',
        duration: 3000
      })
      if (res.code === 401) {
        // 延迟导入避免循环依赖
        const store = require('@/store').default
        const router = require('@/router').default
        store.dispatch('logout')
        router.push('/login')
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    if (error.response && error.response.status === 401) {
      const store = require('@/store').default
      const router = require('@/router').default
      store.dispatch('logout')
      router.push('/login')
      Message({ message: '登录已过期，请重新登录', type: 'error', duration: 3000 })
    } else {
      Message({
        message: error.message || '网络错误',
        type: 'error',
        duration: 3000
      })
    }
    return Promise.reject(error)
  }
)

export default service
